import React from 'react';
import { Card, Form, Input, Button, Checkbox, Row, Col } from 'antd';
import { GoogleOutlined, GithubOutlined, TwitterOutlined } from '@ant-design/icons';
import usecustomStyles from '../../Common/customStyles';
import { Facebook } from 'lucide-react';

import ParticleAuth from '../../Common/ParticleAuth';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const customStyles = usecustomStyles();

const StyleWrapper = styled.div`
    background-color: ${({ theme }) => theme.token.authbgcolor};
`

const SignIn = () => {

    // page title
    document.title = "Sign In" + process.env.REACT_APP_PAGE_TITLE;

    return (
        <StyleWrapper className="auth-page-wrapper">
            <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
              
            </Row>
        </StyleWrapper>
    );
};

export default SignIn;
